/* eslint-disable @angular-eslint/directive-selector */
import { isNil, reduce } from 'lodash';
import { Directive, Input, OnInit } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { map } from 'rxjs';

type FormParser = (model: any) => any;

@Directive({
  selector: '[laFormParsers]',
  standalone: true,
})
export class FormParsersDirective implements OnInit {
  @Input('laFormParsers') parsers: FormParser[] | null | undefined = [];

  constructor(private formDirective: FormGroupDirective) {}

  ngOnInit(): void {
    if (isNil(this.parsers) || !this.parsers.length) {
      return;
    }

    this.formDirective.form.valueChanges
      .pipe(
        map((value) => {
          return reduce(
            this.parsers,
            (parsedVal, parser) => parser(parsedVal),
            value
          );
        })
      )
      .subscribe((parsedValue) => {
        this.formDirective.form.patchValue(parsedValue, { emitEvent: false });
      });
  }
}
